<se-fe-modal *ngIf="showModal" #modal (seFeAfterClose)="onAfterClose()">
  <div seFeModalContent class="modal-content">
    <div class="add-child-profile" [ngClass]="{active: addChildStep === 1, inactive: addChildStep !== 1}">
      <se-po-add-child-profile #childInfo>
      </se-po-add-child-profile>
      <se-fe-button
        class="add-child-profile-btn"
        [seFeDataFullWidth]="true"
        seFeDataEmphasis="high"
        (click)="addProfile()"
        [seFeDataIsLoading]="loading">
        Add Child Profile
      </se-fe-button>
    </div>
    <div
      class="household-invite"
      [ngClass]="{ active: addChildStep === 2, inactive: addChildStep !== 2 }">
      <se-fe-alert *ngIf="error"
        seFeDataType="error">
        {{ error }}
      </se-fe-alert>
      <se-po-household-invite #householdInvite *ngIf="addPersona"
        [profile]="addPersona"
        (invite)="onInvite($event)">
      </se-po-household-invite>
    </div>
    <div
      class="household-review"
      [ngClass]="{ active: addChildStep === 3, inactive: addChildStep !== 3 }">
      <se-fe-alert *ngIf="error"
        seFeDataType="error">
        {{ error }}
      </se-fe-alert>
      <se-po-household-review *ngIf="addPersona"
        [child]="addPersona"
        [parent]="selfPersona"
        [guardianInvites]="guardianInvites"
        (cancelInvite)="onCancelInvite($event)"
        (continue)="onContinue()"
        (addAnother)="onAddAnother()">
      </se-po-household-review>
    </div>
  </div>
</se-fe-modal>
